import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IEducationalStatusType } from "./routeType";

const { key, getPath } = getApi("types.educationalStatus.getAll");

type IExtractedRouteType =
  IEducationalStatusType["EducationalStatusTypeCollectionRetrieve"];

export type IGetEducationalStatusType =
  IPickCollectionQuery<IExtractedRouteType>;

const getEducationalStatusType: Fetcher<
  IGetEducationalStatusType["response"],
  IGetEducationalStatusType["variables"]
> = (params) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetEducationalStatusType = createQuery({
  queryKey: [key],
  fetcher: getEducationalStatusType,
});
